import { z } from "zod";

/**
 * DocumentoSchema
 */

export const DocumentoSchema = z.object({
  idDocumento: z.coerce.number().nullable().default(null),
  statusArquivo: z.coerce.number().nullable().default(null),
  nomeDocumento: z.string().nonempty(),
  dataEmissao: z.coerce.date().nullable().default(null),
  dataVencimento: z.coerce.date().nullable().default(null),
  file: z.instanceof(File).nullable().default(null),
  limparArquivos: z.coerce.boolean().default(false),
});

/**
 * DocumentoForm
 */

export type DocumentoForm = z.infer<typeof DocumentoSchema>;